import { Suspense, lazy, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FooterPage from "./FooterPage/FooterPage";
import Lenis from "lenis";
import ScrollToTop from "./ScrollToTop";

const Home = lazy(() => import("./Home/Home"));
const ContactUs = lazy(() => import("./ReachUs/ContactUs"));
const CareerPage = lazy(() => import("./ReachUs/CareerPage/CareerPage"));
const Insights = lazy(() => import("./BlogPage/Insights"));
const BlogView = lazy(() => import("./BlogPage/BlogView/BlogView"));
const WhoWeAre = lazy(() => import("./WhoWeAre/WhoWeAre"));
const Enrol = lazy(() => import("./WhatWeDo/Enrol"));
const ProductPage = lazy(() => import("./WhatWeDo/ProductPage"));
const TermsAndConditions = lazy(() =>
  import("./TermsAndConditions/TermsAndConditions")
);
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy/PrivacyPolicy"));
const Forbidden = lazy(() => import("./ForbiddenPage/Forbidden"));

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, 
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 2.0, 
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const resizeObserver = new ResizeObserver(() => {
      lenis.resize();
    });
    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Routes>
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/careers" element={<CareerPage />} />
            <Route path="/blog" element={<Insights />} />
            <Route path="/blog/:id" element={<BlogView />} />
            <Route path="/whoWeAre" element={<WhoWeAre />} />
            <Route path="/whatWeDo/Enrol" element={<Enrol />} />
            <Route path="/whatWeDo/:id" element={<ProductPage />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Forbidden />} />
          </Routes>
        </Suspense>
        <FooterPage />
      </BrowserRouter>
    </div>
  );
}